var _path, _ellipse, _ellipse2, _ellipse3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.88614 61.7145C6.61176 61.7145 4.7087 60.9534 3.17697 59.4313C1.64524 57.9091 0.879379 56.0179 0.879379 53.7577C0.879379 51.4976 1.64524 49.6064 3.17697 48.0842C4.7087 46.5621 6.61176 45.801 8.88614 45.801C10.2786 45.801 11.5435 46.1008 12.6807 46.7004C13.8178 47.3001 14.7346 48.1534 15.4308 49.2604C18.4478 47.6922 20.9311 45.4781 22.8806 42.6183C24.83 39.7585 26.0833 36.668 26.6403 33.3469H16.3359C15.8718 35.0997 14.9318 36.4835 13.5161 37.4983C12.1005 38.513 10.5571 39.0204 8.88614 39.0204C6.61176 39.0204 4.7087 38.2594 3.17697 36.7372C1.64524 35.215 0.879379 33.3239 0.879379 31.0637C0.879379 28.8035 1.64524 26.9123 3.17697 25.3902C4.7087 23.868 6.61176 23.1069 8.88614 23.1069C10.5571 23.1069 12.1005 23.6143 13.5161 24.6291C14.9318 25.6439 15.8718 27.0276 16.3359 28.7804H26.6403C26.1297 25.4593 24.8997 22.3689 22.9502 19.5091C21.0007 16.6492 18.4943 14.4352 15.4308 12.8669C14.7346 14.0201 13.8178 14.8849 12.6807 15.4615C11.5435 16.0381 10.2786 16.3264 8.88614 16.3264C6.61176 16.3264 4.7087 15.5653 3.17697 14.0431C1.64524 12.521 0.879379 10.6298 0.879379 8.3696C0.879379 6.10942 1.64524 4.21825 3.17697 2.69609C4.7087 1.17392 6.61176 0.412842 8.88614 0.412842C11.1605 0.412842 13.0636 1.19699 14.5953 2.76528C16.127 4.33357 16.8697 6.22474 16.8233 8.43879C20.8615 10.4222 24.1338 13.2474 26.6403 16.9145C29.1467 20.5815 30.7017 24.5368 31.3051 28.7804H53.3306L49.3055 24.6291L52.8275 21L62.3872 31.0637L52.8275 41L48.8023 37.4983L53.3306 33.3469H31.3051C30.7481 37.6828 29.1699 41.6381 26.5707 45.2129C23.9714 48.7876 20.7222 51.6129 16.8233 53.6886C16.8697 55.9026 16.127 57.7938 14.5953 59.3621C13.0636 60.9304 11.1605 61.7145 8.88614 61.7145Z",
    fill: "#171C8F"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.76107,
    cy: 8.38484,
    rx: 8.3739,
    ry: 8.3216,
    fill: "#0B0F5E"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.76107,
    cy: 31.0633,
    rx: 8.3739,
    ry: 8.3216,
    fill: "#171C8F"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.76107,
    cy: 53.7415,
    rx: 8.3739,
    ry: 8.3216,
    fill: "#256BE4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard2);
export default __webpack_public_path__ + "static/media/card2.52faa40470be4b590e96676ffd874d7d.svg";
export { ForwardRef as ReactComponent };